import React from "react";
import { NavLink } from "react-router-dom";

const TdLink = ({ children, to, className = "", style, disabled = false }) => {
  const cellClassName = `linkTd  ${className}`.trim();
  const linkClassName = `block py-2 px-4 w-full h-full min-w-0 ${disabled ? "cursor-not-allowed text-mute-600" : "cursor-pointer"}`.trim();
  const target = disabled ? undefined : to;

  return (
    <td className={cellClassName} style={style}>
      <div className="flex w-full h-full min-w-0">
        <NavLink to={target} className={linkClassName}>
            {children}
        </NavLink>
      </div>
    </td>
  );
};

export default TdLink;
